import DBEvent from './dbEvent.class';

export default class Memo extends DBEvent {
  get type() { return 'memo'; }

  get via() { return 'memo'; }

  get isMemo() { return true; }
}
